import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

// Instructor magic-link request page. Mirrors the reviewer flow exactly so
// the two staff roles have a consistent sign-in experience.
export default function InstructorLogin() {
  const { data, setData, post, processing, errors } = useForm({ email: '' });

  const submit = (e) => {
    e.preventDefault();
    post('/instructor/login');
  };

  return (
    <AuthLayout>
      <div className="max-w-md mx-auto p-6 sm:p-8">
        <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold text-gray-900">Instructor login</h1>
          <p className="mt-3 text-sm text-gray-600">
            Enter the email address your administrator used to add you as an instructor.
            We'll email you a magic link to access your portal.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-1.5">
                Email address
              </label>
              <input
                id="email"
                type="email"
                required
                autoFocus
                autoComplete="email"
                placeholder="you@example.com"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                className="block w-full rounded-lg border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 focus:outline-none transition"
              />
              {errors.email && <p className="mt-1 text-sm text-rose-600">{errors.email}</p>}
            </div>

            <button
              type="submit"
              disabled={processing}
              className="w-full inline-flex items-center justify-center rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 transition cursor-pointer disabled:opacity-50"
            >
              {processing ? 'Sending…' : 'Email me a login link'}
            </button>
          </form>

          <p className="mt-6 text-xs text-gray-500 text-center">
            Don't have access yet? Contact your administrator to be added as an instructor.
          </p>
          <p className="mt-4 text-xs text-gray-500 text-center">
            <Link href="/login" className="font-semibold text-indigo-600 hover:text-indigo-700">
              ← Back to standard sign-in
            </Link>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
}
